export default "__VITE_ASSET__BRaDe6Xk__"